import { render, staticRenderFns } from "./telephoneCounseling.vue?vue&type=template&id=72f2962e&scoped=true&"
import script from "./telephoneCounseling.vue?vue&type=script&lang=js&"
export * from "./telephoneCounseling.vue?vue&type=script&lang=js&"
import style0 from "./telephoneCounseling.vue?vue&type=style&index=0&id=72f2962e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f2962e",
  null
  
)

export default component.exports